import React, { useState, useMemo, useContext, useEffect } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadExport from "./UploadExport";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getExportsList } from "../../services/ConfigServices";
import axios from "axios";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import {
  typeData, recurrenceData, paramTypeDataTemplate, paramTypeDataExport, paramTypeIndicPeriod,
  paramTypeAlertValueData, paramTypeIndicValueData, formatData, periodData,
  paramTypePatrimoineValueData, paramTypeMapsValueData, paramTypeActionPlanValueData, duplicateData
} from "variables/lists/exports";

const useStyles = makeStyles(styles);

const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border: 0px;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

const ClearButton = styled.button`
    border: 0px solid rgba(0, 0, 0, 0.15);
    border-left: 0px;
    background-color: none;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

const SearchContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

export default function useEntitesTable(props) {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const exportscreate = permis.includes("exports_create");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sorted, setSorted] = useState();
  const [filtered, setFiltered] = useState();
  const [totalRows, setTotalRows] = useState(0);
  //const [idGroup, setIdGroup] = useState(2151);
  const [results, setResults] = useState({});
  const [gridState, setGridState] = useState();
  const [refresh, setRefresh] = useState(false);
  const [permissionList, setPermissionList] = useState([]);
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);

  const classes = useStyles();

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    console.log("refresh",refresh,prevRefresh);
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getExportsList(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);
  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  const refreshTable = () => {
    console.log("refreshTable",!refresh);
    setRefresh(!refresh);
  };

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus={true}
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const UploadComponent = ({ onUpload }) => (
    <>
      {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
      <UploadExport type="button" onClick={onUpload} refetch={refreshTable} setLoading={setLoading} setNotification={setNotification} />

    </>
  );


  const filteredItems = _.get(results, "exports", []).filter(
    (item) =>
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.type && typeData.find((x) => x.id == item.parameters.type) && typeData.find((x) => x.id == item.parameters.type).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.format && formatData.find((x) => x.id == item.parameters.format) && formatData.find((x) => x.id == item.parameters.format).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.recurrence && recurrenceData.find((x) => x.id == item.parameters.recurrence) && recurrenceData.find((x) => x.id == item.parameters.recurrence).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.diffusion && JSON.stringify(item.parameters.diffusion).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.template?.fileName && item.parameters.template.fileName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.groups[0] && groupInfoListById["" + item.parameters.groups[0]] && groupInfoListById["" + item.parameters.groups[0]].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    
    return (
      <>
        {/* <Button
          color={"info"}
          className={classes.actionButton}
          onClick={refreshTable}
          style={{height: "40px", width: "40px", marginRight: "15px"}}
        >
          <AutorenewIcon className={classes.icon} />
        </Button> */}
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {exportscreate ? <UploadComponent key="UploadComponent" onUpload={handleClear} />:<></>}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading: false,
    },
    refreshTable,
    setLoading,
  };
}
